import { app } from '../../app.module'
app
  // お気に入りフォーム用のディレクティブ
  .directive('favoritePostForm', () => {
    return {
      template: require('./favorite-post-form.pug')(),
      restrict: 'E',
      controller: function ($rootScope, $scope) {
        // お気に入り種別
        $scope.favoriteTypes = ['指定なし', '指定する']
        $scope.favoriteType = null

        // お気に入りが指定されている場合、セット
        if ($rootScope.favoriteFilter) {
          $scope.favoriteType = $rootScope.favoriteFilter
        }

        // お気に入りのフィルタリング
        $scope.filterFavoritePost = function () {
          $rootScope.favoriteFilter = $scope.favoriteType

          $scope.$emit('changeFilterData', {
            type: 'favoritePostFilter',
            value: $scope.favoriteType,
          })
        }
      },
    }
  })
